import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  DealerQuestionDto,
  LaunchDarklyService,
  UserQuestionDto,
  AuctionItemState,
  QuestionsState,
  UpdateSelectedQuestions,
  ConfigurationState
} from 'remarketing-angular-library';
import { QuestionBlockComponent } from '../question-block/question-block.component';
import { generateHashCode } from '../../../../../app/utilities/utilities';
import { QuestionDrawerComponent } from '../question-drawer/question-drawer.component';
import { StateIndicatorComponent } from '../../../../../shared/components/state-indicator/state-indicator.component';
import { NgClass } from '@angular/common';

// @dynamic
@Component({
    selector: 'lib-question',
    templateUrl: './question.component.html',
    styleUrls: ['./question.component.scss'],
    imports: [NgClass, StateIndicatorComponent, QuestionBlockComponent, QuestionDrawerComponent]
})
export class QuestionComponent implements OnInit {
  @Input() dealer: DealerQuestionDto;
  @Input() identifier: string;
  @ViewChild(QuestionBlockComponent) questionBlock: QuestionBlockComponent;
  toggleActiveQuestion = false;
  selectedQuestion: UserQuestionDto;
  userUuid: string;
  auctionItemStatus: string;
  showUserName = false;
  showDealershipName: boolean;

  selectedQuestion$: Observable<UserQuestionDto>;
  constructor(private readonly store: Store, private readonly _launchDarklyService: LaunchDarklyService) {}

  ngOnInit() {
    this.selectedQuestion$ = this.store.select(QuestionsState.dealerSelectedQuestion(this.dealer.dealerUuid));
    this.selectedQuestion$.subscribe(question => {
      this.selectedQuestion = question;
    });

    this.showUserName = this._launchDarklyService.getFeatureFlag('sell-buyerUserNameEnabled', false);

    this.store.select(AuctionItemState.auctionItem).subscribe(item => {
      if (item) {
        this.auctionItemStatus = item.auctionItemStatus;
      }
    });
    this.showDealershipName = this._launchDarklyService.getFeatureFlag('showBuyingDealershipName', false);
  }

  toggleDrawer(question: UserQuestionDto) {
    this.toggleActiveQuestion = !this.toggleActiveQuestion;

    if (question === this.selectedQuestion) {
      this.store.dispatch(new UpdateSelectedQuestions(this.dealer.dealerUuid, null));
    } else {
      this.store.dispatch(new UpdateSelectedQuestions(this.dealer.dealerUuid, question));
    }

    // focus on toggle button
    if (!this.toggleActiveQuestion) {
      setTimeout(() => {
        this.questionBlock.focus();
      }, 100);
    }
  }

  hasAnswer(questions): boolean {
    return questions.some(q => !!q.answer);
  }

  get questionStatus() {
    if (this.auctionItemStatus !== 'ACTIVE') {
      return 'grey';
    } else if (this.dealer.openQuestionCount > 0) {
      return 'danger';
    } else {
      let userQuestions = [];

      this.dealer.userQuestions.forEach(userQuestion => {
        userQuestions.push(userQuestion.questions[0]);
      });

      userQuestions = userQuestions.map(ele => ele.withdrawnDate);

      if (!userQuestions.includes(undefined)) {
        return '';
      }

      return 'success';
    }
  }

  setUserUuid(userUuid: string) {
    this.userUuid = userUuid;
  }
}
